export default class wt {
  constructor(t, s, i, h, l) {
    (this.triggerId = t),
      (this.Qn = s),
      (this.Jn = i),
      (this.Un = h),
      (this.Vn = l),
      (this.triggerId = t),
      (this.Qn = s),
      (this.Jn = i),
      (this.Un = h),
      (this.Vn = l);
  }
  static fromJson(t, s, i, h, l) {
    return null == t || null == t.trigger_id
      ? null
      : new wt(t.trigger_id, s, i, h, l);
  }
}
